import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { CompareMatrixBannerType } from "../types/CompareMatrixPricing";
import UnderlineAnimation from "../Animations/UnderlineAnimation";

const CompareMatrixBanner: React.FC<CompareMatrixBannerType> = ({
  includeBuyNowToggle,
  buyNowInfo,
  onOfferChange,
  onClickHandler,
}) => {
  const { buyNow, _30DayTrial, headline } = { ...buyNowInfo };
  const {
    toggleCopy: toggleCopyBN,
    anchorLink,
    subCopy: subCopyBN,
    ctaCopy: ctaCopyBN,
    ctaLink: ctaLinkBN,
    ctaUrl: ctaUrlBN,
  } = { ...buyNow };
  const {
    toggleCopy: toggleCopy30,
    subCopy: subCopy30,
    ctaCopy: ctaCopy30,
    ctaLink: ctaLink30,
    ctaUrl: ctaUrl30,
  } = { ..._30DayTrial };
  const selectedOffer =
    anchorLink && includeBuyNowToggle
      ? anchorLink.toLowerCase().replace(/\s/g, "")
      : "";
  const [currentOffer, setCurrentOffer] = useState("");

  // Sets #hash in URL based on current offer
  const handleUpdateAnchorUrl = (currentOffer: string) => {
    setCurrentOffer(currentOffer);
    if (onOfferChange) {
      onOfferChange(currentOffer);
    }
    window.location.hash = currentOffer;
  };

  // If there is no hash offer to begin, set it on load.
  useEffect(() => {
    if (window.location.hash === "") {
      handleUpdateAnchorUrl(selectedOffer);
    } else {
      const offer = window.location.hash.substring(1);
      handleUpdateAnchorUrl(offer);
    }
  }, []);

  // Determines URL of CTA based on offer and if reference or external link
  const determineUrl = () => {
    if (currentOffer === "buynow") {
      return ctaLinkBN ? ctaLinkBN?.value?.data?.url : ctaUrlBN;
    } else {
      return ctaLink30 ? ctaLink30?.value?.data?.url : ctaUrl30;
    }
  };

  const url = determineUrl();

  return (
    <>
      {includeBuyNowToggle && (
        <div className="compare-matrix-banner compare-matrix-pricing__font-set md:gap-0 md:justify-start md:flex-wrap sm:mb-md bg-sun-200 rounded-sm p-sm mb-12 flex gap-5 justify-between items-center">
          <div className="compare-matrix-banner__copy compare-matrix-pricing__font-set md:basis-full md:pb-[21px] basis-[65%]">
            <h2 className="compare-matrix-banner__header compare-matrix-pricing__font-set md:text-2xl md:mb-3 body--text-extra-large font-medium mb-xxxs !leading-7">
              {headline}
            </h2>
            <p className="compare-matrix-banner__subcopy compare-matrix-pricing__font-set body--text-large mb-xs">
              {currentOffer !== "30daytrial" ? (
                <>{subCopyBN}</>
              ) : (
                <>{subCopy30}</>
              )}
            </p>
            <UnderlineAnimation direction="reverse">
              <a
                className="compare-matrix-banner__cta compare-matrix-pricing__font-set md:leading-none font-semibold"
                onClick={onClickHandler}
                href={url}
              >
                {currentOffer !== "30daytrial" ? (
                  <>{ctaCopyBN}</>
                ) : (
                  <>{ctaCopy30}</>
                )}
              </a>
            </UnderlineAnimation>
          </div>
          <div className="compare-matrix-banner__btns  sm:w-full sm:max-w-[300px] md:w-auto md:text-sm md:p-2.5 md:h-auto flex items-center justify-between w-[345px] p-3 bg-white rounded-circle">
            <button
              onClick={() => handleUpdateAnchorUrl("buynow")}
              className="compare-matrix-banner__btn-discount font-semibold relative py-3.5 px-4 mr-xxxxs leading-none rounded-circle transition-colors motion-reduce:transition-none bg-transparent"
            >
              {currentOffer !== "30daytrial" && (
                <motion.span
                  layoutId="pill"
                  className="absolute inset-0 bg-sun-600"
                  style={{ borderRadius: 99 }}
                  transition={{ type: "spring", bounce: 0.25, duration: 0.5 }}
                />
              )}
              <span
                className={`${
                  currentOffer !== "30daytrial"
                    ? ""
                    : "text-forest-700 [transform:translateZ(0)]"
                } compare-matrix-pricing__banner-toggle-text compare-matrix-pricing__font-set relative z-10`}
              >
                {toggleCopyBN}
              </span>
            </button>
            <button
              onClick={() => handleUpdateAnchorUrl("30daytrial")}
              className="compare-matrix-banner__btn-trial font-semibold relative py-3.5 px-4 leading-none rounded-circle transition-colors motion-reduce:transition-none bg-transparent"
            >
              {currentOffer === "30daytrial" && (
                <motion.span
                  layoutId="pill"
                  className="absolute inset-0 bg-sun-600"
                  style={{ borderRadius: 99 }}
                  transition={{ type: "spring", bounce: 0.25, duration: 0.5 }}
                />
              )}
              <span
                className={`${
                  currentOffer === "30daytrial" || currentOffer === ""
                    ? ""
                    : "text-forest-700 [transform:translateZ(0)]"
                } compare-matrix-pricing__banner-toggle-text compare-matrix-pricing__font-set relative z-10`}
              >
                {toggleCopy30}
              </span>
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default CompareMatrixBanner;
